'use client';

import React, { useEffect, useRef, useState } from 'react';
import { PetInsurerBouncer, PetInsurerBouncerProps } from '../../wag-react/components/floating-action-buttons/components/PetInsurerBouncer';
import { Box } from '../../wag-react/next-components/box';
import { theme } from '../../wag-react/themes/base-theme';
import { initializeQuoteEngine, WagQuoteFormScript } from '../PetInsurer/WagQuoteFormScript';
export type PetInsurerBouncerAndWagQuoteFormProps = Omit<PetInsurerBouncerProps, 'onLoad'> & {
  onLoad?: () => void;
};
export const PetInsurerBouncerAndWagQuoteForm = ({
  onLoad,
  ...rest
}: PetInsurerBouncerAndWagQuoteFormProps) => {
  const [isOpen, setIsOpen] = useState(false);
  const hasLoadedScriptRef = useRef(false);
  const onLoadRef = useRef(onLoad);
  useEffect(() => {
    if (hasLoadedScriptRef.current) {
      return undefined;
    }
    if (!isOpen) {
      return undefined;
    }
    const timeoutRef = setTimeout(() => {
      if (onLoadRef.current) {
        onLoadRef.current();
      } else {
        initializeQuoteEngine();
      }
      hasLoadedScriptRef.current = true;
    }, 500);
    return () => {
      clearTimeout(timeoutRef);
    };
  }, [isOpen]);
  return <Box position="fixed" right="16px" bottom="30px" zIndex={3} data-sentry-element="Box" data-sentry-component="PetInsurerBouncerAndWagQuoteForm" data-sentry-source-file="index.tsx">
      <Box height="max-content" minWidth="min(90vw, 380px)" maxHeight="70vh" p="16px" backgroundColor={theme.colors.white} borderRadius="8px" boxShadow="0 0 9px 0 rgba(0,0,0,0.16)" style={{
      clipPath: isOpen ? 'circle(100%)' : 'circle(0% at 100% 100%)',
      display: isOpen ? 'block' : 'none',
      transition: 'all .4s ease-in-out',
      overflowY: 'auto'
    }} data-sentry-element="Box" data-sentry-source-file="index.tsx">
        <WagQuoteFormScript initOnMount={false} data-sentry-element="WagQuoteFormScript" data-sentry-source-file="index.tsx" />
      </Box>
      <PetInsurerBouncer isOpen={isOpen} onClick={() => setIsOpen(prev => !prev)} {...rest} data-sentry-element="PetInsurerBouncer" data-sentry-source-file="index.tsx" />
    </Box>;
};